"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneDisplayFormats = exports.phoneTypeNames = exports.phoneTypeTitles = exports.DEFAULT_COUNTRY = void 0;
const phone_1 = require("../../field-values/phone");
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
exports.DEFAULT_COUNTRY = "US";
exports.phoneTypeTitles = {
    [phone_1.PhoneTypes.office]: (0, intl_1.$t)(texts_1.phoneFieldText.office),
    [phone_1.PhoneTypes.mobile]: (0, intl_1.$t)(texts_1.phoneFieldText.mobile),
    [phone_1.PhoneTypes.home]: (0, intl_1.$t)(texts_1.phoneFieldText.home),
    [phone_1.PhoneTypes.fax]: (0, intl_1.$t)(texts_1.phoneFieldText.fax),
    [phone_1.PhoneTypes.other]: (0, intl_1.$t)(texts_1.phoneFieldText.other),
};
exports.phoneTypeNames = {
    [phone_1.PhoneTypes.office]: "office",
    [phone_1.PhoneTypes.mobile]: "cell",
    [phone_1.PhoneTypes.home]: "home",
    [phone_1.PhoneTypes.fax]: "fax",
    [phone_1.PhoneTypes.other]: "other",
};
exports.phoneDisplayFormats = [
    "number_flag_type",
    "number_with_flag",
    "number_only",
];
